export default __webpack_public_path__ + "static/media/Helm of Untamed Violence.15259651.jpg";